import React, { useEffect, useState } from 'react';
import { Funnel } from '@ant-design/plots';



const FunnelChart = ({ data, xLabel, yLabel, color, xAxisLabel, yAxisLabel }) => {
  const [chartColor, setChartColor] = useState([]);
  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    if (color == "raceFunnel") {
      setChartColor([
        "#3f81af",
        "#37948e",
        "#95ba60",
        "#e8d23c",
        "#f36523",
        "#9d405f",
        "#487386",
        "#2b8a84",
        "#8db05c",
      ]);
    } else {
      setChartColor(["#724dad", "#4945a8", "#32669e", "#2193ae", "#16ada0"]);
    }
  };

  const config = {
    data,
    xField: 'type',
    yField: 'value',
    shapeField: 'pyramid',
    label: [
      {
       text: (d) => `${d.type}\n${d.value}`,
        position: 'inside',
        fontSize: 16,
      },
      {
        render: ($, _, i) => {
          if (i)
            return (
              <div
                style={{
                  height: 1,
                  width: 30,
                  background: '#aaa',
                  margin: '0 20',
                }}
              ></div>
            );
        },
        position: 'top-right',
      },
      {
        text: (d, i, data) => {
          if (i) return ((d.value / data[i - 1].value) * 100).toFixed(2) + '%';
        },
        position: 'top-right',
        textAlign: 'left',
        textBaseline: 'middle',
        dx: 40,
      },
    ],
        legend: {
      color: {
        title: false,
        position: 'bottom',
        rowPadding: 5,
      },
    },
  };

  //   data,
  //   color: chartColor,
  //   xField: xLabel,
  //   yField: yLabel,
  //   shapeField: 'pyramid',
  //   label:
  //   {
  //     text: (d) => `${d.type}\n${d.value}`,
  //     transform: [{ type: 'contrastReverse' }],
  //   },
  //   legend: {
  //     color: {
  //       title: false,
  //       position: 'bottom',
  //       rowPadding: 5,
  //     },
  //   },
  // };
  return <Funnel {...config} />

};

export default FunnelChart;
